import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import User360Dark from "@/common/assets/image/products/icons/User360Dark.svg"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description from "@/common/components/Description"
import ProductCTA from "@/common/components/ProductCTA"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"

const User360Page = () => {
  const { t } = useTranslation(["user360"])
  const { t: commonT } = useTranslation(["common"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/user360"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/user360"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/user360"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/user360"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={User360Dark.src}
          bannerType={ProductNames.User360}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          titleh3={t("Banner.subtitle")}
          description={t("Banner.description")}
        />
        <SectionLine />
        <Description
          items={[
            {
              titles: [{ text: t("Desc.1.title") }],
              content: t("Desc.1.content")
            },
            {
              titles: [{ text: t("Desc.2.title") }],
              content: t("Desc.2.content")
            }
          ]}
        />
        <ProductCTA
          title={t("CTA.title")}
          desc={t("CTA.desc")}
          primaryButton={{ text: t("CTA.button") }}
        />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.WalletBuilder,
                ProductNames.CompliancePro,
                ProductNames.NFTAirdrop
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.GameFi, SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "user360"
    ]))
  }
})

export default User360Page
